import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
import embLabels from "../../../config/emb-labels-en.json";
const BatterySLD = ({x,y,index}) => {
     const { 
    CBAssetList,
    siteType,
    assetDetailsReset,
    UserScope,
    callSnackbar,
    CBAssetListDispatch,
    selectedValuesHandler,
    selectedAssetHandler,
    assetConfigDataHandler,
    projectTypeValue,
  } = useContext(DesignAssetContext);
const batterySelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) { 
      let assetBlock = "assetBatteryDetailsBlock";

      if(siteType === embLabels.GRID_CONNECTED&& (projectTypeValue==="MGaaS IEC" || projectTypeValue==="MGaaS ETO" )){
        assetBlock="assetBessHybridDetailsBlock"
      }
      const selectedAssetValue = "selectedAsset";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: index,
        },
      });
      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      selectedAssetHandler(embLabels.ASSETS, index);
      assetConfigDataHandler(index);
    } else {
      callSnackbar(
        "error",
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
    return (
         <g id="battery">
        <svg
          x={x}
          y={y}
          width="195px"
          height="130px"
          viewBox="0 0 10 149"
          onClick={batterySelectHandler}
          
        >
          <title>{CBAssetList?.[index]?.configData.name}</title>
          <g id="Design" fill="none" fillRule="evenodd">
            <g
              id="Design/Assets-_-00"
              transform="translate(-892.000000, -372.000000)"
            >
              <g
                id="SLD/Production/Uniline/Tobedefine"
                transform="translate(892.000000, 372.000000)"
              >
                <g id="Group-7">
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="96"
                    height="144"
                  ></rect>
                  <line
                    x1="48.5"
                    y1="96"
                    x2="48.5"
                    y2="144"
                    id="Line-2"
                    strokeWidth="4"
                    strokeLinecap="round"
                    stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                    strokeLinejoin="round"
                  ></line>
                  <circle
                    id="Oval"
                    stroke="#42B4E6"
                    strokeWidth="3"
                    cx="48"
                    cy="56"
                    r="55"
                    style={CBAssetList?.[index]?.uiData.selected ? {} : { display: "none" }}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="rgba(0, 135, 205, 0.2)"
                  ></circle>
                  <circle
                    id="Oval"
                    strokeWidth="3"
                    fill="var(--se-background-alternative)"
                    cx="48"
                    cy="55"
                    r="46.5"
                    stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  ></circle>
                  <text
                    id="segment_energy_infra"
                    fontFamily="se-icon"
                    stroke="var(--se-sld-circline)"
                    fontSize="52"
                    fontWeight="normal"
                    fill="#0F0F0F"
                  >
                    <tspan x="22" y="76">
                      battery2_general
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </g>
    );
};
export default BatterySLD;